import ProcurementDetailsTable from "./ProcurementDetailsTable";
import { ProductType } from "@type/inventory/procurements";

type Props = {
  onAddTagOpen: (data: ProductType) => void;
  procurementData: any;
};

const ProcurementsDetails = ({ onAddTagOpen, procurementData }: Props) => {
  return (
    <div className="mt-10">
      <ProcurementDetailsTable
        onAddTagOpen={onAddTagOpen}
        procurementData={procurementData}
      />
    </div>
  );
};

export default ProcurementsDetails;
